<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Event</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
        <div class="card-form-head-bdy">
          <p>Status {{ form.is_active ? "aktif" : "tidak aktif" }}</p>
          <label class="switch">
            <input v-model="form.is_active" type="checkbox" :disabled="isWatch" />
            <span class="slider"></span>
          </label>
        </div>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button :class="['tab', activeTab === 'id' ? 'active-tab' : '']" @click="activeTab = 'id'">
          Bahasa Indonesia
        </button>
        <button :class="['tab', activeTab === 'en' ? 'active-tab' : '']" @click="activeTab = 'en'">
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Informasi Umum Program</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama Event</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.name" class="form-input"
                placeholder="Masukkan Nama Event" dense clearable
                :rules="[!!form.name || 'Wajib diisi!']"></v-text-field>
            </div>
            <div class="content-form">
              <p>Slug Name</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.slug_name" class="form-input"
                placeholder="Masukkan Slug Name" dense clearable
                :rules="[!!form.slug_name || 'Wajib diisi!']"></v-text-field>
            </div>
            <div class="content-form">
              <p>Batch Series</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.batch" class="form-input" type="number"
                placeholder="Batch Series" dense clearable :min="1"
                @input="() => { if (form.batch < 1) form.batch = 1; }"></v-text-field>
            </div>
            <div class="content-form">
              <p>Level Pelatihan</p>
              <v-select :disabled="isWatch" class="form-input" :items="levelList" v-model="form.level" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Level"></v-select>
            </div>
            <div class="content-form">
              <p>DiLengkapi LMS</p>
              <v-select :disabled="isWatch" class="form-input" :items="lmsConfirmList" v-model="form.is_lms_compatible"
                solo :item-text="'name'" :item-value="'value'" placeholder="Pilih LMS Support"></v-select>
            </div>
            <div class="content-form">
              <p>Metode Pelaksanaan</p>
              <v-select :disabled="isWatch" class="form-input" :items="methods" v-model="form.method" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Metode"></v-select>
            </div>
            <div class="content-form" v-if="form.method === 'Online'">
              <p>Link Pelaksanaan Event</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.learning_url" class="form-input"
                placeholder="Gmeet, Zoom, atau lainnya" dense clearable></v-text-field>
            </div>
            <div v-else>
              <div class="content-form">
                <p>Nama Lokasi Pelaksanaan</p>
                <v-text-field :disabled="isWatch" outlined v-model="form.location_name" class="form-input"
                  placeholder="Masukkan Nama Lokasi" dense clearable></v-text-field>
              </div>
              <div class="content-form">
                <p>Alamat Lokasi Pelaksanaan</p>
                <v-textarea :disabled="isWatch" outlined v-model="form.location_address" class="form-input"
                  placeholder="Masukkan Alamat Lokasi" rows="3" clearable></v-textarea>
              </div>
              <div class="content-form">
                <p>URL Link Maps Lokasi Pelaksanaan</p>
                <v-text-field :disabled="isWatch" outlined v-model="form.location_map" class="form-input"
                  placeholder="Masukkan URL Link Maps" dense clearable></v-text-field>
              </div>
            </div>
            <div class="content-form">
              <p>Narasumber</p>
              <div v-for="(item, idx) in form.instructors" :key="idx" class="session-nb-3">
                <v-autocomplete :disabled="imum" :label="`Pilih narasumber ${idx + 1}`" outlined
                  v-model="form.instructors[idx]" :items="instructors" class="form-input mt-2 no-space" dense
                  :item-text="'name'" :item-value="'id'"></v-autocomplete>
                <div @click="form.instructors.splice(idx, 1)" style="cursor: pointer" v-if="idx != 0 && !isWatch">
                  <Trash :width="38" :height="38" />
                </div>
                <div @click="addNewInstructor" style="cursor: pointer"
                  v-if="form.instructors.length - 1 === idx && !isWatch">
                  <AddIcon />
                </div>
              </div>
            </div>
            <v-row class="mt-5">
              <v-col cols="6">
                <div class="content-form">
                  <p>Kuota Peserta</p>
                  <v-select :disabled="isWatch" class="form-input" :items="typeLimitEvent" v-model="limitOfEvent" solo
                    :item-text="'name'" :item-value="'value'" placeholder="Pilih Kuota"></v-select>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="content-form">
                  <p>Batas Kuota</p>
                  <v-text-field :disabled="!limitOfEvent || isWatch" outlined v-model="form.participant_quota"
                    class="form-input" type="number" :min="1" dense clearable></v-text-field>
                </div>
              </v-col>
            </v-row>
            <div class="content-form mt-5">
              <p>Deskripsi Singkat Thumbnail</p>
              <v-textarea :disabled="isWatch" outlined v-model="form.caption" class="form-input"
                placeholder="Tulis caption ..." rows="3" clearable></v-textarea>
            </div>
            <div class="content-form">
              <p>Deskripsi Event</p>
              <vue-editor v-model="form.description" :editorToolbar="$helpers.customToolBar()" class="form-input"
                :disabled="isWatch"></vue-editor>
            </div>
          </div>
        </div>

        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Berkas Gambar (Website Desktop)</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Banner Thumbnail</p>
              <span class="alert-info">Rekomendasi dimensi file 400 x 200 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.desktop.thumbnail" accept="image/*" placeholder="Unggah Berkas Gambar"
                class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.desktop.thumbnail == null">
                  <ImageModal :src="form.img_urls.desktop.thumbnail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
            <div class="content-form mt-3">
              <p>Banner Detail Produk</p>
              <span class="alert-info">Rekomendasi dimensi file 1.600 x 420 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.desktop.product_detail" accept="image/*"
                placeholder="Unggah Berkas Gambar" class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.desktop.product_detail == null">
                  <ImageModal :src="form.img_urls.desktop.product_detail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
            <div class="content-form mt-3">
              <p>Banner Rincian Pembelian</p>
              <span class="alert-info">Rekomendasi dimensi file 200 x 200 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.desktop.purchase_detail" accept="image/*"
                placeholder="Unggah Berkas Gambar" class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.desktop.purchase_detail == null">
                  <ImageModal :src="form.img_urls.desktop.purchase_detail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
          </div>
        </div>

        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Berkas Gambar (Website Mobile)</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Banner Thumbnail</p>
              <span class="alert-info">Rekomendasi dimensi file 400 x 200 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.mobile.thumbnail" accept="image/*" placeholder="Unggah Berkas Gambar"
                class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.mobile.thumbnail == null">
                  <ImageModal :src="form.img_urls.mobile.thumbnail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
            <div class="content-form mt-3">
              <p>Banner Detail Produk</p>
              <span class="alert-info">Rekomendasi dimensi file 1.600 x 420 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.mobile.product_detail" accept="image/*" placeholder="Unggah Berkas Gambar"
                class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.mobile.product_detail == null">
                  <ImageModal :src="form.img_urls.mobile.product_detail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
            <div class="content-form mt-3">
              <p>Banner Rincian Pembelian</p>
              <span class="alert-info">Rekomendasi dimensi file 200 x 200 px, kapasitas maksimal 1 MB</span>
              <v-file-input v-model="imgModel.mobile.purchase_detail" accept="image/*"
                placeholder="Unggah Berkas Gambar" class="form-upload" prepend-icon="" outlined :disabled="isWatch">
                <template v-slot:prepend-inner v-if="imgModel.mobile.purchase_detail == null">
                  <ImageModal :src="form.img_urls.mobile.purchase_detail" width="76.31" height="37" radius="3" />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
            </div>
          </div>
        </div>

        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Jadwal Pelaksanaan</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form" v-if="form.is_lms_compatible">
              <p>Hari Pertemuan</p>
              <v-text-field :disabled="isWatch" outlined v-model="formClass.class_detail.days"
                :rules="[!!formClass.class_detail.days || 'Wajib diisi!']" class="form-input"
                placeholder="Senin, Rabu, & Jumat" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Sesi Pelaksanaan</p>
              <v-select :disabled="isWatch" class="form-input" :items="listSessionSchedule" v-model="sessionSchedule"
                solo @change="checkScheduleType" :item-text="'name'" :item-value="'value'"
                placeholder="Pilih Sesi"></v-select>
            </div>
            <div v-for="(item, idx) in form.session_schedules" :key="idx">
              <div v-if="sessionSchedule === 2" class="session-numb">
                <p style="font-weight: bold">Sesi {{ idx + 1 }}</p>
                <div @click="form.session_schedules.splice(idx, 1)" style="cursor: pointer" v-if="idx != 0 && !isWatch">
                  <Strip />
                </div>
              </div>
              <div class="content-form">
                <p>Hari & Tanggal Pelaksanaan</p>
                <div class="container-date pt-2" v-if="sessionSchedule === 1">
                  <div class="container-date-left">
                    <v-row no-gutters>
                      <v-col cols="3" class="pt-2"> Mulai </v-col>
                      <v-col cols="8">
                        <v-text-field :disabled="isWatch" outlined type="date"
                          :rules="[!!item.date_start || 'Wajib diisi!']" v-model="item.date_start" class="form-input"
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="container-date-right">
                    <v-row no-gutters>
                      <v-col cols="3" class="pt-2"> Selesai </v-col>
                      <v-col cols="8">
                        <v-text-field :disabled="isWatch" outlined type="date"
                          :rules="[!!item.date_end || 'Wajib diisi!']" v-model="item.date_end" class="form-input"
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <v-text-field v-else :disabled="isWatch" outlined type="date"
                  :rules="[!!item.date_start || 'Wajib diisi!']" v-model="item.date_start" class="form-input"
                  dense></v-text-field>
              </div>
              <div class="content-form">
                <p>Jam Pelaksanaan</p>
                <div class="container-date pt-2">
                  <div class="container-date-left">
                    <v-row no-gutters>
                      <v-col cols="3" class="pt-2"> Mulai </v-col>
                      <v-col cols="8">
                        <v-text-field :disabled="isWatch" outlined type="time"
                          :rules="[!!item.start_time || 'Wajib diisi!']" v-model="item.start_time" class="form-input"
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="container-date-right">
                    <v-row no-gutters>
                      <v-col cols="3" class="pt-2"> Selesai </v-col>
                      <v-col cols="8">
                        <v-text-field :disabled="isWatch" outlined type="time"
                          :rules="[!!item.end_time || 'Wajib diisi!']" v-model="item.end_time" class="form-input"
                          dense></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-button" @click="addSessionSchedule" v-if="sessionSchedule === 2 && !isWatch">
              <div class="line"></div>
              <div class="button">+ Tambah Sesi</div>
              <div class="line"></div>
            </div>
          </div>
        </div>

        <div class="cart-form" v-if="form.is_lms_compatible">
          <v-card-title class="card-form-head-2">
            <h1>Support Class</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Prefix Code</p>
              <v-text-field :disabled="isWatch" outlined v-model="formClass.class.prefix_code"
                :rules="[!!formClass.class.prefix_code || 'Wajib diisi!']" class="form-input" placeholder="Prefix Code"
                dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Metode Pembelajaran</p>
              <vue-editor v-model="formClass.class_detail.learning_objective" :editorToolbar="$helpers.customToolBar()"
                class="form-input" :disabled="isWatch"></vue-editor>
            </div>
            <div class="content-form mt-6">
              <p>Metode Penyampaian</p>
              <vue-editor v-model="formClass.class_detail.learning_method" :editorToolbar="$helpers.customToolBar()"
                class="form-input" :disabled="isWatch"></vue-editor>
            </div>
            <div class="content-form mt-5">
              <p>Link Materi (Global)</p>
              <v-text-field :disabled="isWatch" outlined v-model="formClass.class.material" class="form-input"
                placeholder="Link Materi" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Link Group Chat</p>
              <v-text-field :disabled="isWatch" outlined v-model="formClass.class.group_chat_link" class="form-input"
                placeholder="Link Group Chat" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Link Konsultasi</p>
              <v-text-field :disabled="isWatch" outlined v-model="formClass.class.consultancy_link" class="form-input"
                placeholder="Link Konsultasi" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Link Rubrik Penilaian</p>
              <v-text-field :disabled="isWatch" outlined v-model="classLms.rubrik_url" class="form-input"
                placeholder="Link Rubrik Penilaian" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Total Quiz</p>
              <v-text-field :disabled="isWatch" outlined v-model="classLms.total_quiz"
                :rules="[!!classLms.total_quiz || 'Wajib diisi!']" class="form-input" type="number" :min="1"
                @input="() => { if (classLms.total_quiz < 1) classLms.total_quiz = 1; }" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Jadwal Konsultasi</p>
              <v-row no-gutters class="pt-2">
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="3" class="pt-2"> Mulai </v-col>
                    <v-col cols="8">
                      <v-text-field :disabled="isWatch" outlined type="datetime-local"
                        v-model="formClass.class.start_consultation_date" class="form-input" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="3" class="pt-2"> Selesai </v-col>
                    <v-col cols="8">
                      <v-text-field :disabled="isWatch" outlined type="datetime-local"
                        v-model="formClass.class.end_consultation_date" class="form-input" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="content-form mb-6">
              <p>Instruksi Final Project</p>
              <vue-editor v-model="classLms.instruction_final_project" :editorToolbar="$helpers.customToolBar()"
                class="form-input" :disabled="isWatch"></vue-editor>
            </div>
          </div>
        </div>

        <div class="cart-form" v-if="form.is_lms_compatible">
          <v-card-title class="card-form-head-2">
            <h1>Syarat dan Target Peserta (Informasi untuk LMS)</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Target Audience</p>
              <div style="margin: 10px 0">
                <v-text-field :disabled="isWatch" v-for="(data, idx) in formClass.class_detail.target_audience"
                  :key="idx" outlined v-model="formClass.class_detail.target_audience[idx].level"
                  class="form-input no-space" dense></v-text-field>
                <div style="display: flex; gap: 20px">
                  <Button name="+" width="40px" height="35px" title="Add Tag" v-if="!isWatch"
                    @click="() => formClass.class_detail.target_audience.push({ level: '' })" />
                  <Button name="-" width="40px" height="35px" title="Remove Tag" outline
                    v-if="formClass.class_detail.target_audience.length && !isWatch"
                    @click="() => formClass.class_detail.target_audience.splice(formClass.class_detail.target_audience.length - 1, 1)" />
                </div>
              </div>
            </div>
            <div class="content-form mt-5">
              <p>Syarat & Ketentuan Mengikuti Kelas</p>
              <div class="list-event" v-for="(item2, idx) in formClass.class_detail.requirements" :key="idx">
                <div class="icon-plus-bc" @click="formClass.class_detail.requirements.splice(idx, 1)" v-if="!isWatch">
                  <TrashIcon :width="25" :height="25" />
                </div>
                <b>Ke {{ idx + 1 }}</b>
                <v-text-field :disabled="isWatch" outlined placeholder="Syarat Ketentuan" v-model="item2.name"
                  class="form-input no-space" dense></v-text-field>
              </div>
              <div class="add-button" @click="addListRequirements" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Requirements</div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Materi Silabus</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Informasi Materi Silabus?</p>
              <div class="spacing-switch">
                <v-switch v-model="form.isSyllabuses" color="primary" hide-details style="margin-top: -5px"
                  :disabled="isWatch"></v-switch>
              </div>
            </div>
            <div class="content-form mt-5" v-if="form.isSyllabuses || form.is_lms_compatible">
              <p>Daftar Materi Event</p>
              <div class="list-event" v-for="(item, idx) in form.syllabuses" :key="idx">
                <div class="icon-plus" @click="addSubSession(idx)" v-if="!isWatch">
                  <AddIcon />
                </div>
                <b>Sesi {{ idx + 1 }}</b>
                <div v-for="(item2, idx2) in item" :key="idx2" class="session-nb-3">
                  <v-text-field :disabled="isWatch" outlined v-model="form.syllabuses[idx][idx2]"
                    class="form-input mt-2 no-space" dense clearable></v-text-field>
                  <div @click="onRemoveEvent(idx, idx2)" style="cursor: pointer" v-if="!isWatch">
                    <Trash :width="38" :height="38" />
                  </div>
                </div>
              </div>
              <div class="add-button" @click="addSubSession(null)" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Sesi</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="content-form" v-if="form.is_lms_compatible">
              <p>Link Materi Per Sesi</p>
              <div class="list-event" v-for="(item2, idx) in classLms.materials_link" :key="idx">
                <div class="icon-plus-bc" @click="classLms.materials_link.splice(idx, 1)" v-if="idx > 0 && !isWatch">
                  <TrashIcon :width="25" :height="25" />
                </div>
                <b>Ke {{ idx + 1 }}</b>
                <v-text-field :disabled="isWatch" outlined v-model="item2.iteration" class="form-input mt-2 no-space"
                  placeholder="Nomor / Code" dense></v-text-field>
                <v-text-field :disabled="isWatch" outlined placeholder="Deskripsi" v-model="item2.description"
                  class="form-input no-space" dense></v-text-field>
              </div>
              <div class="add-button" @click="addListMateri" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Link Materi</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="content-form" v-if="form.is_lms_compatible">
              <p>Link Record</p>
              <div class="list-event" v-for="(item2, idx) in classLms.record_list" :key="idx">
                <div class="icon-plus-bc" @click="classLms.record_list.splice(idx, 1)" v-if="idx > 0 && !isWatch">
                  <TrashIcon :width="25" :height="25" />
                </div>
                <b>Ke {{ idx + 1 }}</b>
                <v-text-field :disabled="isWatch" outlined v-model="item2.iteration" class="form-input mt-2 no-space"
                  placeholder="Sesi ke" dense></v-text-field>
                <v-text-field :disabled="isWatch" outlined placeholder="Link record class" v-model="item2.description"
                  class="form-input no-space" dense></v-text-field>
              </div>
              <div class="add-button" @click="addRecordList" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Link Record</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="content-form" v-if="form.is_lms_compatible">
              <p>Instruksi TPM</p>
              <div class="list-event mt-5" v-for="(item, idx) in classLms.instruction_tpm" :key="idx">
                <div class="icon-plus-bc" @click="classLms.instruction_tpm.splice(idx, 1)" v-if="idx > 0 && !isWatch">
                  <TrashIcon :width="25" :height="25" />
                </div>
                <v-text-field :disabled="isWatch" outlined label="Sesi Ke"
                  v-model="classLms.instruction_tpm[idx].iteration" class="form-input no-space" dense></v-text-field>
                <vue-editor v-model="classLms.instruction_tpm[idx].description"
                  :editorToolbar="$helpers.customToolBar()" class="form-input" :disabled="isWatch"></vue-editor>
              </div>
              <div class="add-button" @click="addInstructionTpm" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Instruksi</div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Soal Kurasi</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Dilengkapi Soal Kurasi?</p>
              <v-select :disabled="isWatch" class="form-input" :items="isCurationList" v-model="form.is_curation" solo
                :item-text="'name'" :item-value="'value'" placeholder="Pilih Kurasi"></v-select>
            </div>
            <div class="content-form" v-if="form.is_curation">
              <p>Pertanyaan</p>
              <div class="question" v-for="(n, idx) in form.question" :key="idx">
                <div class="question-remove" @click="removeQuestion(idx)" v-if="!isWatch">
                  <CloseX />
                </div>
                <div class="num">{{ idx + 1 }}</div>
                <div class="card">
                  <div class="mt-5">
                    <h4>Tipe Soal</h4>
                    <v-select :disabled="isWatch" class="form-input mt-2" :items="typeQuestion" v-model="n.isEssay" solo
                      :item-text="'name'" :item-value="'value'"></v-select>
                  </div>
                  <div>
                    <h4>Soal</h4>
                    <v-text-field :disabled="isWatch" outlined v-model="n.question" class="form-input mt-2"
                      :placeholder="`Pertanyaan ${idx + 1}`" dense></v-text-field>
                  </div>
                  <div v-if="!n.isEssay">
                    <h4>Pilihan Ganda</h4>
                    <div v-for="(item2, idx2) in n.choices" :key="idx2"
                      :class="`question-multiple-choice ${n.correct_answer.includes(idx2) ? 'question-true' : ''}`">
                      <div class="action-buttons">
                        <div class="check-button" @click="toggleCorrectAnswer(idx, idx2)" :class="{ 'active-check': n.correct_answer.includes(idx2) }">
                          <SuccessIcon :width="24" :height="24" />
                        </div>
                        <div class="remove-button" @click="onRemoveChoice(idx, idx2)" v-if="!isWatch">
                          <CloseX :width="24" :height="24" />
                        </div>
                      </div>
                      <span class="choice-label">{{ multiple_choice_option[idx2] }}.</span>
                      <v-text-field :disabled="isWatch" outlined dense v-model="item2.description"
                        class="form-input choice-input"></v-text-field>
                    </div>
                    <p>Pilihan Lain</p>
                    <div class="spacing-switch">
                      <v-switch v-model="n.isOtherChoice" color="primary" hide-details style="margin-top: -5px"
                        :disabled="isWatch"></v-switch>
                    </div>
                    <div class="add-button" @click="onAddChoice(idx)" v-if="!isWatch">
                      <div class="line"></div>
                      <div class="button">+ Tambah Pilihan</div>
                      <div class="line"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-button" @click="addQuestion" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Tambah Pertanyaan</div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
 <div class="cart-form">
        <v-card-title class="card-form-head-2" style="border: none">
          <h1>
            Harga Event
          </h1>
        </v-card-title>
        <div class="mt-5">
          <div class="content-form">
            <p>Tipe Tiket</p>
            <v-select :disabled="isWatch" class="form-input" :items="typeTiket" v-model="form.is_event_paid" solo
              :item-text="'name'" :item-value="'value'">
            </v-select>
          </div>
          <div v-if="form.is_event_paid">
            <div class="content-form">
              <p>Harga Tiket</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.price" class="form-input" placeholder="Harga"
                type="number" :min="1" @input="() => {
                  if (form.price < 0) {
                    form.price = 0;
                  }
                }
                  " dense clearable></v-text-field>
            </div>

            <div class="content-form">
              <p>Potongan harga</p>
              <v-text-field :disabled="isWatch" outlined v-model="form.discount_price" class="form-input" :min="0"
                prefix="IDR" type="number" @input="() => {
                  if (form.discount_price < 0) {
                    form.discount_price = 0;
                  }
                }
                  " dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Durasi Earlybird</p>
              <v-row no-gutters class="pt-2">
                <v-col cols="6">
                  <v-row no-gutters>
                    <v-col cols="4" class="pt-2"> Mulai </v-col>
                    <v-col cols="8">
                      <v-text-field :disabled="isWatch" outlined type="datetime-local"
                        v-model="form.start_discount_date" class="form-input" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="5 ml-5">
                  <v-row no-gutters>
                    <v-col cols="3" class="pt-2"> Selesai </v-col>
                    <v-col cols="9">
                      <v-text-field :disabled="isWatch" outlined type="datetime-local" v-model="form.end_discount_date"
                        class="form-input" dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="content-form">
            <p>Batas Pembelian Tiket</p>
            <v-text-field :disabled="isWatch" outlined type="datetime-local"
              :rules="[!!form.registration_close_date || 'Wajib diisi!']" v-model="form.registration_close_date"
              class="form-input" dense></v-text-field>
          </div>
        </div>
      </div>
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Benefit Event</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="list-event" v-for="(item, idx) in form.benefits" :key="idx" style="margin-left: 0px;">
              <div class="session-nb-3">
                <v-text-field :disabled="isWatch" outlined v-model="form.benefits[idx]" class="form-input mt-2 no-space"
                  dense clearable></v-text-field>
                <div @click="form.benefits.splice(idx, 1)" style="cursor: pointer" v-if="!isWatch">
                  <Trash :width="38" :height="38" />
                </div>
              </div>
            </div>
            <div class="add-button" @click="form.benefits.push('')" v-if="!isWatch">
              <div class="line"></div>
              <div class="button">+ Tambah Benefit</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Event Name</p>
              <v-text-field :disabled="isWatch" outlined v-model="formEng.name" class="form-input"
                placeholder="Enter Event Name" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Thumbnail Caption</p>
              <v-textarea :disabled="isWatch" outlined v-model="formEng.caption" class="form-input"
                placeholder="Write caption ..." rows="3" clearable></v-textarea>
            </div>
            <div class="content-form">
              <p>Event Description</p>
              <vue-editor v-model="formEng.description" :editorToolbar="$helpers.customToolBar()" class="form-input"
                :disabled="isWatch"></vue-editor>
            </div>
            <div v-if="form.method !== 'Online'" class="content-form">
              <p>Event Location Name</p>
              <v-text-field :disabled="isWatch" outlined v-model="formEng.location_name" class="form-input"
                placeholder="Enter Location Name" dense clearable></v-text-field>
            </div>
            <div v-if="form.method !== 'Online'" class="content-form">
              <p>Event Location Address</p>
              <v-textarea :disabled="isWatch" outlined v-model="formEng.location_address" class="form-input"
                placeholder="Enter Location Address" rows="3" clearable></v-textarea>
            </div>
            <div v-if="form.method !== 'Online'" class="content-form">
              <p>Event Location Maps URL</p>
              <v-text-field :disabled="isWatch" outlined v-model="formEng.location_map" class="form-input"
                placeholder="Enter Maps URL" dense clearable></v-text-field>
            </div>
            <div class="content-form">
              <p>Event Benefits</p>
              <div class="list-event" v-for="(item, idx) in formEng.benefits" :key="idx" style="margin-left: 0px;">
                <div class="session-nb-3">
                  <v-text-field :disabled="isWatch" outlined v-model="formEng.benefits[idx]"
                    class="form-input mt-2 no-space" dense clearable></v-text-field>
                  <div @click="formEng.benefits.splice(idx, 1)" style="cursor: pointer" v-if="!isWatch">
                    <Trash :width="38" :height="38" />
                  </div>
                </div>
              </div>
              <div class="add-button" @click="formEng.benefits.push('')" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Add Benefit</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="content-form" v-if="form.isSyllabuses || form.is_lms_compatible">
              <p>Syllabus Materials</p>
              <div class="list-event" v-for="(item, idx) in formEng.syllabuses" :key="idx">
                <div class="icon-plus" @click="addSubSessionEng(idx)" v-if="!isWatch">
                  <AddIcon />
                </div>
                <b>Session {{ idx + 1 }}</b>
                <div v-for="(item2, idx2) in item" :key="idx2" class="session-nb-3">
                  <v-text-field :disabled="isWatch" outlined v-model="formEng.syllabuses[idx][idx2]"
                    class="form-input mt-2 no-space" dense clearable></v-text-field>
                  <div @click="onRemoveEventEng(idx, idx2)" style="cursor: pointer" v-if="!isWatch">
                    <Trash :width="38" :height="38" />
                  </div>
                </div>
              </div>
              <div class="add-button" @click="addSubSessionEng(null)" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Add Session</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="content-form" v-if="form.is_curation">
              <p>Curation Questions</p>
              <div class="question" v-for="(n, idx) in formEng.question" :key="idx">
                <div class="question-remove" @click="removeQuestionEng(idx)" v-if="!isWatch">
                  <CloseX />
                </div>
                <div class="num">{{ idx + 1 }}</div>
                <div class="card">
                  <div class="mt-5">
                    <h4>Question Type</h4>
                    <v-select :disabled="isWatch" class="form-input mt-2" :items="typeQuestion" v-model="n.isEssay" solo
                      :item-text="'name'" :item-value="'value'"></v-select>
                  </div>
                  <div>
                    <h4>Question</h4>
                    <v-text-field :disabled="isWatch" outlined v-model="n.question" class="form-input mt-2"
                      :placeholder="`Question ${idx + 1}`" dense></v-text-field>
                  </div>
                  <div v-if="!n.isEssay">
                    <h4>Multiple Choice Options</h4>
                    <div v-for="(item2, idx2) in n.choices" :key="idx2"
                      :class="`question-multiple-choice ${n.correct_answer.includes(idx2) ? 'question-true' : ''}`">
                      <div class="action-buttons">
                        <div class="check-button" @click="toggleCorrectAnswerEng(idx, idx2)" :class="{ 'active-check': n.correct_answer.includes(idx2) }">
                          <SuccessIcon :width="24" :height="24" />
                        </div>
                        <div class="remove-button" @click="onRemoveChoiceEng(idx, idx2)" v-if="!isWatch">
                          <CloseX :width="24" :height="24" />
                        </div>
                      </div>
                      <span class="choice-label">{{ multiple_choice_option[idx2] }}.</span>
                      <v-text-field :disabled="isWatch" outlined dense v-model="item2.description"
                        class="form-input choice-input"></v-text-field>
                    </div>
                    <p>Other Option</p>
                    <div class="spacing-switch">
                      <v-switch v-model="n.isOtherChoice" color="primary" hide-details style="margin-top: -5px"
                        :disabled="isWatch"></v-switch>
                    </div>
                    <div class="add-button" @click="onAddChoiceEng(idx)" v-if="!isWatch">
                      <div class="line"></div>
                      <div class="button">+ Add Option</div>
                      <div class="line"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-button" @click="addQuestionEng" v-if="!isWatch">
                <div class="line"></div>
                <div class="button">+ Add Question</div>
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button name="Batalkan" outline class="me-3"
          @click="$router.push(`/event-category/${$route.params.id_category}/event`)" />
        <Button :name="isEdit ? 'Simpan' : 'Simpan & Publish'" :width="isEdit ? '156px' : '200px'" @click="onSubmit"
          :disabled="!validData" style="background-color: #2d46cf; color: #ffffff" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from "@/components/icons/Arrow.vue";
import AddIcon from "@/components/icons/Add.vue";
import Trash from "@/components/icons/Trash.vue";
import Strip from "@/components/icons/Strip.vue";
import TrashIcon from "@/components/icons/Trash.vue";
import SuccessIcon from "@/components/icons/Success.vue";
import CloseX from "@/components/icons/CloseX.vue";
import ImageModal from "@/components/ImageModal.vue";
import { VueEditor } from "vue2-editor";
import moment from "moment";

export default {
  name: "FormEvent",
  components: {
    Loading,
    Button,
    Popup,
    Arrow,
    AddIcon,
    Trash,
    Strip,
    TrashIcon,
    SuccessIcon,
    CloseX,
    ImageModal,
    VueEditor,
  },
  computed: {
    validData() {
      return (
        this.form.name &&
        this.form.slug_name &&
        this.form.description &&
        this.form.method &&
        this.form.level &&
        this.form.is_lms_compatible !== null &&
        this.form.session_schedules.every(
          (session) => session.date_start && session.start_time && session.end_time
        ) &&
        (!this.form.is_lms_compatible ||
          (this.formClass.class.prefix_code &&
            this.formClass.class_detail.days &&
            this.classLms.total_quiz)) &&
        this.form.registration_close_date
      );
    },
  },
  data() {
    return {
      id: null,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      multiple_choice_option: this.$helpers.multipleChoices(),
      limitOfEvent: false,
      sessionSchedule: 0,
      instructors: [],
      methods: [
        { name: "Daring (Online via Zoom)", value: "Online" },
        { name: "Luring (Offline in office)", value: "Offline" },
      ],
      levelList: [
        { name: "Semua Level", value: "Semua Level" },
        { name: "Dasar", value: "Dasar" },
        { name: "Menengah", value: "Menengah" },
        { name: "Profesional", value: "Profesional" },
      ],
      typeLimitEvent: [
        { name: "Tidak Terbatas", value: false },
        { name: "Terbatas", value: true },
      ],
      lmsConfirmList: [
        { name: "Support", value: true },
        { name: "Manual", value: false },
      ],
      typeTiket: [
        { name: "Berbayar", value: true },
        { name: "Gratis", value: false },
      ],
      isCurationList: [
        { name: "Support", value: true },
        { name: "Tidak", value: false },
      ],
      typeQuestion: [
        { name: "Pilihan Ganda", value: false },
        { name: "Essay", value: true },
      ],
      listSessionSchedule: [
        { name: "Hanya 1 Sesi", value: 0 },
        { name: "Lebih dari 1 Sesi Beruntun", value: 1 },
        { name: "Lebih dari 1 Sesi Acak", value: 2 },
      ],
      imgModel: {
        desktop: {
          thumbnail: null,
          product_detail: null,
          purchase_detail: null,
        },
        mobile: {
          thumbnail: null,
          product_detail: null,
          purchase_detail: null,
        },
      },
      form: {
        name: "",
        caption: "",
        description: "",
        category_id: 0,
        price: 0,
        batch: 1,
        slug_name: "",
        level: "",
        is_lms_compatible: false,
        total_session: 1,
        method: "Online",
        isSyllabuses: false,
        syllabuses: [],
        learning_url: "",
        benefits: [""],
        instructors: [""],
        label_discount: "",
        question: [],
        is_curation: false,
        class_id: 0,
        participant_quota: 0,
        session_schedules: [
          { date_start: "", date_end: "", start_time: "", end_time: "" },
        ],
        img_urls: {
          desktop: {
            thumbnail: "",
            product_detail: "",
            purchase_detail: "",
          },
          mobile: {
            thumbnail: "",
            product_detail: "",
            purchase_detail: "",
          },
        },
        is_event_paid: false,
        registration_close_date: "",
        discount_price: 0,
        start_discount_date: "",
        end_discount_date: "",
        is_active: true,
        session_schedule_type: "",
        location_name: "",
        location_address: "",
        location_map: "",
      },
      formEng: {
        name: "",
        caption: "",
        description: "",
        benefits: [""],
        syllabuses: [],
        question: [],
      },
      classLms: {
        instruction_final_project: "",
        total_quiz: 0,
        rubrik_url: "",
        instruction_tpm: [],
        materials_link: [],
        record_list: [],
      },
      formClass: {
        class: {
          consultancy_link: "",
          group_chat_link: "",
          material: "",
          prefix_code: "",
          start_consultation_date: "",
          end_consultation_date: "",
          learning_link: "",
          collaboration_feat: "",
          type_class: "",
          type: "",
          class_category_id: 8,
          class_sub_category_id: 4,
        },
        class_detail: {
          class_id: 0,
          hours: "",
          days: "",
          learning_objective: "",
          learning_info_list: [],
          why_info_list: [],
          requirements: [
            { name: "Peserta memiliki gawai untuk pelaksanaan kelas yang terdiri dari smartphone atau laptop" },
            { name: "Peserta harus mengakses kelas melalui LMS HiColleagues" },
            { name: "Peserta wajib datang di seluruh pertemuan dan mengikuti setiap rangkaian pelatihan, termasuk evaluasi berupa test maupun unjuk keterampilan" },
            { name: "Memiliki akses internet yang baik untuk mendukung proses pembelajaran" },
            { name: "Peserta tidak buta huruf" },
            { name: "Pria dan wanita dengan rentang usia 18 - 57 tahun" },
            { name: "Minimal pendidikan dari peserta adalah SMA sederajat" },
          ],
          summary_syllabus: [],
          skkni: "",
          learning_method:
            "Metode ajar yang digunakan adalah ceramah interaktif melalui webinar, penugasan, dan bahan bacaan dengan penugasan praktek",
          special_purpose: "",
          list_competency: [],
          target_audience: [],
        },
      },
    };
  },
  watch: {
    limitOfEvent(e) {
      if (e) {
        this.form.participant_quota = 1;
      } else {
        this.form.participant_quota = 0;
      }
    },
    "form.isSyllabuses": function (newVal) {
      if (!newVal) {
        this.formEng.syllabuses = [];
      } else if (this.formEng.syllabuses.length === 0) {
        this.formEng.syllabuses = this.form.syllabuses.map(() => [""]);
      }
    },
    "form.is_curation": function (newVal) {
      if (!newVal) {
        this.formEng.question = [];
      } else if (this.formEng.question.length === 0) {
        this.formEng.question = this.form.question.map(() => ({
          question: "",
          isEssay: false,
          isOtherChoice: false,
          choices: [],
          correct_answer: [],
        }));
      }
    },
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataEvent();
    },
    async getInstructor() {
      try {
        const resp = await this.$crm_http.get("/v1/instructor");
        this.instructors = resp.data.data.instructors;
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load instructors.";
        this.isPopup = true;
      }
    },
    async getDataEvent() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/event/" + this.id);
        const data = resp.data.data.event;
        this.form = {
          ...data,
          session_schedules: data.session_schedules ?? [
            { date_start: "", date_end: "", start_time: "", end_time: "" },
          ],
          img_urls: Object.keys(data.img_urls).length
            ? data.img_urls
            : {
              desktop: { thumbnail: "", product_detail: "", purchase_detail: "" },
              mobile: { thumbnail: "", product_detail: "", purchase_detail: "" },
            },
          is_event_paid: data.price ? true : false,
          instructors: data.instructors ? data.instructors.map((item) => item.id) : [""],
          registration_close_date: moment(data.registration_close_date).format("YYYY-MM-DDTHH:mm"),
          start_discount_date: data.start_discount_date
            ? moment(data.start_discount_date).format("YYYY-MM-DDTHH:mm")
            : "",
          end_discount_date: data.end_discount_date
            ? moment(data.end_discount_date).format("YYYY-MM-DDTHH:mm")
            : "",
        };
        this.sessionSchedule = this.listSessionSchedule.find(
          (item) => item.name === data.session_schedule_type
        )?.value;
        this.limitOfEvent = !!data.participant_quota;
        if (data.syllabuses.length) {
          this.form.isSyllabuses = true;
        }
        await this.getBilingual();
        if (this.form.is_lms_compatible && this.form.class_id) {
          await this.getClassLms(this.form.class_id);
          await this.getDataClass(this.form.class_id);
        }
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=event&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          name: resp.name || "",
          caption: resp.caption || "",
          description: resp.description || "",
          benefits: resp.benefits || [""],
          syllabuses: resp.syllabuses || [],
          question: resp.question || [],
          location_name: resp.location_name || "",
          location_address: resp.location_address || "",
          location_map: resp.location_map || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async getClassLms(classId) {
      try {
        const resp = await this.$lms_http.get(`/v1/class/${classId}`);
        this.classLms = resp.data.data.class;
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load LMS data.";
        this.isPopup = true;
      }
    },
    async getDataClass(classId) {
      try {
        const resp = await this.$crm_http.get(`/v1/class/${classId}`);
        const data = resp.data.data;
        this.formClass = {
          class: {
            ...data.class,
            instructor_id: data.class.instructor?.ID || 0,
            class_category_id: data.class.class_category?.ID || 8,
            class_sub_category_id: data.class.class_sub_category?.ID || 4,
            start_consultation_date: this.$helpers.getUniqDate(
              data.class.consultancy_schedule?.split(" - ")[0],
              "YYYY-MM-DDTHH:mm:ss"
            ),
            end_consultation_date: this.$helpers.getUniqDate(
              data.class.consultancy_schedule?.split(" - ")[1],
              "YYYY-MM-DDTHH:mm:ss"
            ),
          },
          class_detail: {
            ...data.class.class_detail,
            start_discount_date: this.$helpers.getUniqDate(
              data.class.class_detail.start_discount_date,
              "YYYY-MM-DDTHH:mm"
            ),
            end_discount_date: this.$helpers.getUniqDate(
              data.class.class_detail.end_discount_date,
              "YYYY-MM-DDTHH:mm"
            ),
            private_start_discount_date: this.$helpers.getUniqDate(
              data.class.class_detail.private_start_discount_date,
              "YYYY-MM-DDTHH:mm"
            ),
            private_end_discount_date: this.$helpers.getUniqDate(
              data.class.class_detail.private_end_discount_date,
              "YYYY-MM-DDTHH:mm"
            ),
            benefits_req: data.class.class_detail.benefits || [],
            summary_syllabus: data.class.class_detail.summary_syllabus || [],
          },
        };
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load class data.";
        this.isPopup = true;
      }
    },
    async uploadImage(imageFile) {
      const imageForm = new FormData();
      imageForm.append("attachment", imageFile);
      try {
        const response = await this.$crm_http.post("/v1/upload-file", imageForm);
        return response.data.data.upload_image_response.url_w_query;
      } catch (error) {
        console.error("Failed to upload image:", error);
        return null;
      }
    },
    async handleImageUpload() {
      for (const [device, images] of Object.entries(this.imgModel)) {
        for (const [key, imageFile] of Object.entries(images)) {
          if (imageFile) {
            const imageUrl = await this.uploadImage(imageFile);
            if (imageUrl) {
              this.form.img_urls[device][key] = imageUrl;
            }
          }
        }
      }
    },
    addNewInstructor() {
      this.form.instructors.push("");
    },
    addSessionSchedule() {
      this.form.session_schedules.push({
        date_start: "",
        date_end: "",
        start_time: "",
        end_time: "",
      });
    },
    addListMateri() {
      this.classLms.materials_link.push({
        iteration: this.classLms.materials_link.length + 1,
        description: "",
      });
    },
    addRecordList() {
      this.classLms.record_list.push({
        iteration: this.classLms.record_list.length + 1,
        description: "",
      });
    },
    addInstructionTpm() {
      this.classLms.instruction_tpm.push({
        iteration: this.classLms.instruction_tpm.length + 1,
        description: "",
      });
    },
    addListRequirements() {
      this.formClass.class_detail.requirements.push({ name: "" });
    },
    addQuestion() {
      this.form.question.push({
        question: "",
        isEssay: false,
        isOtherChoice: false,
        choices: [],
        correct_answer: [],
      });
      if (this.form.is_curation) {
        this.formEng.question.push({
          question: "",
          isEssay: false,
          isOtherChoice: false,
          choices: [],
          correct_answer: [],
        });
      }
    },
    addQuestionEng() {
      this.formEng.question.push({
        question: "",
        isEssay: false,
        isOtherChoice: false,
        choices: [],
        correct_answer: [],
      });
    },
    toggleCorrectAnswer(questionIndex, choiceIndex) {
      const question = this.form.question[questionIndex];
      if (question.correct_answer.includes(choiceIndex)) {
        question.correct_answer = question.correct_answer.filter((idx) => idx !== choiceIndex);
      } else {
        question.correct_answer.push(choiceIndex);
      }
    },
    toggleCorrectAnswerEng(questionIndex, choiceIndex) {
      const question = this.formEng.question[questionIndex];
      if (question.correct_answer.includes(choiceIndex)) {
        question.correct_answer = question.correct_answer.filter((idx) => idx !== choiceIndex);
      } else {
        question.correct_answer.push(choiceIndex);
      }
    },
    onAddChoice(questionIndex) {
      this.form.question[questionIndex].choices.push({ description: "" });
      if (this.form.is_curation) {
        this.formEng.question[questionIndex].choices.push({ description: "" });
      }
    },
    onAddChoiceEng(questionIndex) {
      this.formEng.question[questionIndex].choices.push({ description: "" });
    },
    onRemoveChoice(questionIndex, choiceIndex) {
      this.form.question[questionIndex].choices.splice(choiceIndex, 1);
      this.form.question[questionIndex].correct_answer = this.form.question[questionIndex].correct_answer.filter(
        (idx) => idx !== choiceIndex
      );
      this.form.question[questionIndex].correct_answer = this.form.question[questionIndex].correct_answer.map(
        (idx) => (idx > choiceIndex ? idx - 1 : idx)
      );
      if (this.form.is_curation) {
        this.formEng.question[questionIndex].choices.splice(choiceIndex, 1);
        this.formEng.question[questionIndex].correct_answer = this.formEng.question[questionIndex].correct_answer.filter(
          (idx) => idx !== choiceIndex
        );
        this.formEng.question[questionIndex].correct_answer = this.formEng.question[questionIndex].correct_answer.map(
          (idx) => (idx > choiceIndex ? idx - 1 : idx)
        );
      }
    },
    onRemoveChoiceEng(questionIndex, choiceIndex) {
      this.formEng.question[questionIndex].choices.splice(choiceIndex, 1);
      this.formEng.question[questionIndex].correct_answer = this.formEng.question[questionIndex].correct_answer.filter(
        (idx) => idx !== choiceIndex
      );
      this.formEng.question[questionIndex].correct_answer = this.formEng.question[questionIndex].correct_answer.map(
        (idx) => (idx > choiceIndex ? idx - 1 : idx)
      );
    },
    removeQuestion(idx) {
      this.form.question.splice(idx, 1);
      if (this.form.is_curation) {
        this.formEng.question.splice(idx, 1);
      }
    },
    removeQuestionEng(idx) {
      this.formEng.question.splice(idx, 1);
    },
    checkScheduleType() {
      if (this.sessionSchedule === 0) {
        this.form.session_schedules[0].date_end = "";
        this.form.session_schedules.splice(1);
      } else if (this.sessionSchedule === 1) {
        this.form.session_schedules.splice(1);
      } else {
        this.form.session_schedules = this.form.session_schedules.map((item) => ({
          ...item,
          date_end: "",
        }));
      }
    },
    addSubSession(i) {
      if (i !== null) {
        this.form.syllabuses[i].push("");
        if (this.form.isSyllabuses) {
          this.formEng.syllabuses[i].push("");
        }
        return;
      }
      this.form.syllabuses.push([""]);
      if (this.form.isSyllabuses) {
        this.formEng.syllabuses.push([""]);
      }
      this.form.total_session = this.form.syllabuses.length;
    },
    addSubSessionEng(i) {
      if (i !== null) {
        this.formEng.syllabuses[i].push("");
        return;
      }
      this.formEng.syllabuses.push([""]);
    },
    onRemoveEvent(i, i2) {
      this.form.syllabuses[i].splice(i2, 1);
      if (this.form.isSyllabuses) {
        this.formEng.syllabuses[i].splice(i2, 1);
      }
      if (this.form.syllabuses[i].length === 0) {
        this.form.syllabuses.splice(i, 1);
        if (this.form.isSyllabuses) {
          this.formEng.syllabuses.splice(i, 1);
        }
        this.form.total_session = this.form.syllabuses.length;
      }
    },
    onRemoveEventEng(i, i2) {
      this.formEng.syllabuses[i].splice(i2, 1);
      if (this.formEng.syllabuses[i].length === 0) {
        this.formEng.syllabuses.splice(i, 1);
      }
    },
    mapFormToClassForm() {
      const syllabuses = this.form.syllabuses.map((item, idx) => ({
        description: `<ul>${item.map((item2) => `<li>${item2}</li>`).join("")}</ul>`,
        session: "Pertemuan " + (idx + 1),
      }));
      const classForm = {
        class: {
          name: this.form.name,
          image_url: this.form.img_urls.desktop?.product_detail || "",
          description: this.form.description,
          prefix_code: this.formClass.class.prefix_code,
          meta_description: this.form.description,
          class_category_id: this.formClass.class.class_category_id,
          level: this.form.level,
          class_sub_category_id: this.form.category_id,
          slug_name: this.form.slug_name,
          thumbnail_url: this.form.img_urls.desktop?.thumbnail || "",
          small_image_url: this.form.img_urls.mobile?.thumbnail || "",
          learning_link: this.form.learning_url,
          consultancy_link: this.formClass.class.consultancy_link,
          consultancy_schedule:
            this.$helpers.getUniqDate(this.formClass.class.start_consultation_date, "YYYY-MM-DDTHH:mm") +
            " - " +
            this.$helpers.getUniqDate(this.formClass.class.end_consultation_date, "YYYY-MM-DDTHH:mm"),
          group_chat_link: this.formClass.class.group_chat_link,
          instructor_id: Number(this.form.instructors[0]) || 0,
          material: this.formClass.class.material,
          method: this.form.method,
          total_audience: Number(this.form.participant_quota),
          start_time: this.form.session_schedules[0]?.start_time || "",
          end_time: this.form.session_schedules[0]?.end_time || "",
          session_schedule: this.form.session_schedules,
          is_recommend: false,
          start_consultation_date: this.formClass.class.start_consultation_date,
          end_consultation_date: this.formClass.class.end_consultation_date,
          collaboration_feat: this.formClass.class.collaboration_feat,
          type_class: this.formClass.class.type_class,
          type: this.formClass.class.type,
          registration_close_date: this.form.registration_close_date,
        },
        class_detail: {
          class_id: 0,
          hours: `${this.form.session_schedules[0].start_time} - ${this.form.session_schedules[0].end_time} WIB`,
          batch_id: this.form.batch,
          price: Number(this.form.price) || 1,
          discount_price: Number(this.form.discount_price),
          private_price: Number(this.form.price) || 1,
          private_discount_price: Number(this.form.discount_price),
          session_total: this.form.total_session,
          days: this.formClass.class_detail.days,
          start_discount_date: this.form.start_discount_date,
          end_discount_date: this.form.end_discount_date,
          private_start_discount_date: this.form.start_discount_date,
          private_end_discount_date: this.form.end_discount_date,
          is_discount: Number(this.form.discount_price) > 0,
          learning_objective: this.formClass.class_detail.learning_objective,
          benefits_req: this.form.benefits,
          label_discount: this.form.label_discount,
          learning_info_list: this.formClass.class_detail.learning_info_list,
          why_info_list: this.formClass.class_detail.why_info_list,
          requirements: this.formClass.class_detail.requirements,
          summary_syllabus: this.formClass.class_detail.summary_syllabus,
          skkni: this.formClass.class_detail.skkni,
          learning_method: this.formClass.class_detail.learning_method,
          special_purpose: this.formClass.class_detail.special_purpose,
          list_competency: this.formClass.class_detail.list_competency,
          syllabuses: syllabuses,
          target_audience: this.formClass.class_detail.target_audience,
        },
      };
      const classLmsReq = {
        class_id: this.form.class_id,
        name: classForm.class.name,
        level: classForm.class.level,
        image_url: classForm.class.image_url,
        category: classForm.class.class_category_id,
        slug_name: classForm.class.slug_name,
        learning_link: this.form.learning_url,
        group_chat_link: classForm.class.group_chat_link,
        material_link: classForm.class.material,
        learning_method: classForm.class.method,
        final_project_link: "",
        days: classForm.class_detail.days,
        hours: `${classForm.class.start_time} - ${classForm.class.end_time} WIB`,
        syllabuses: classForm.class_detail.syllabuses,
        instruction_final_project: this.classLms.instruction_final_project,
        materials_link: this.classLms.materials_link,
        total_quiz: Number(this.classLms.total_quiz),
        total_tpm: this.classLms.instruction_tpm.length,
        rubrik_url: this.classLms.rubrik_url,
        instruction_tpm: this.classLms.instruction_tpm,
        prefix_code: classForm.class.prefix_code,
        skkni: classForm.class_detail.skkni,
        record_list: this.classLms.record_list,
        list_competency: classForm.class_detail.list_competency,
      };
      return [classForm, classLmsReq];
    },
    async onSubmit() {
      if (!this.form.is_event_paid) {
        this.form.price = 0;
        this.form.discount_price = 0;
      }
      this.isLoading = true;
      await this.handleImageUpload();
      try {
        const eventPayload = {
          ...this.form,
          category_id: Number(this.$route.params.id_category),
          price: Number(this.form.price),
          discount_price: Number(this.form.discount_price),
          participant_quota: Number(this.form.participant_quota),
          batch: Number(this.form.batch),
          session_schedule_type: this.listSessionSchedule.find(
            (item) => item.value === this.sessionSchedule
          )?.name,
        };

        let eventId = this.id;
        if (this.isEdit) {
          await this.$crm_http.put(`/v1/event/${this.id}`, eventPayload);
        } else {
          const resp = await this.$crm_http.post("/v1/event", eventPayload);
          eventId = resp.data.data.event.id;
        }

        this.id = eventId;
        await this.onSubmitBilingual();

        if (this.form.is_lms_compatible) {
          const [classForm, classLmsReq] = this.mapFormToClassForm();
          if (this.form.class_id) {
            await this.$crm_http.put(`/v1/class/${this.form.class_id}`, classForm);
            await this.$lms_http.put(`/v1/class/${this.form.class_id}`, classLmsReq);
          } else {
            const classResp = await this.$crm_http.post("/v1/class", classForm);
            classLmsReq.class_id = classResp.data.data.class_id;
            await this.$lms_http.post("/v1/class", classLmsReq);
            await this.$crm_http.put(`/v1/event/${eventId}`, { class_id: classResp.data.data.class_id });
          }
        }
        this.isLoading = false;
        this.$router.push(`/event-category/${this.$route.params.id_category}/event`);
      } catch (err) {
        this.message = err.response?.data?.message || "Failed to save event.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual() {
      const translatedData = {
        name: this.formEng.name,
        caption: this.formEng.caption,
        description: this.formEng.description,
        benefits: this.formEng.benefits,
        syllabuses: [],
        question: [],
        location_name: "",
        location_address: "",
        location_map: ""
      };
      if (this.form.isSyllabuses) {
        translatedData.syllabuses = this.formEng.syllabuses;
      }
      if (this.form.is_curation) {
        translatedData.question = this.formEng.question;
      }
      if (this.form.method !== 'Online') {
        translatedData.location_name = this.formEng.location_name;
        translatedData.location_address = this.formEng.location_address;
        translatedData.location_map = this.formEng.location_map;
      }
      const payload = {
        table_name: "event",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify(translatedData),
      };

      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        this.message = err.response?.data?.message || "Failed to save bilingual data.";
        this.isPopup = true;
        throw err;
      }
    },
  },
  mounted() {
    this.checkingType();
    this.getInstructor();
  },
};
</script>

<style scoped>
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}

.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.card-form-head h1 {
  font-weight: 700;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}

.card-form-head-bdy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.card-form-head-bdy p {
  color: #575966;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  font-family: 'Poppins', sans-serif;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 0px;
}

.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}

.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}

.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}

.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}

.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}

.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.language-section {
  margin-bottom: 30px;
}

.content-form {
  margin-top: 15px;
}

.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}

.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}

.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}

.form-upload {
  border-radius: 14px !important;
}

.no-space {
  margin-bottom: -20px;
}

.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #162ca2;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.alert-info {
  font-size: 14px;
  color: #7b7e8c;
}

.list-event {
  margin-top: 15px;
  position: relative;
  margin-left: 60px;
}

.icon-plus {
  position: absolute;
  bottom: 0px;
  left: -56px;
  cursor: pointer;
}

.icon-plus-bc {
  position: absolute;
  bottom: 0px;
  left: -56px;
  cursor: pointer;
}

.add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
  cursor: pointer;
}

.add-button .line {
  flex: 1;
  height: 1px;
  background-color: #7b7e8c;
}

.add-button .button {
  padding: 8px 16px;
  background-color: #2d46cf;
  color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  transition: background-color 0.2s ease;
}

.add-button .button:hover {
  background-color: #162ca2;
}

.session-nb-3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.question {
  position: relative;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.question-remove {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-remove {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.question-remove:hover {
  background-color: #f0f0f0;
}

.question-multiple-choice {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.question-true {
  background-color: #e6f4ea; /* Light green background for correct answers */
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.check-button {
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  background-color: #f0f0f0;
  transition: background-color 0.2s;
}

.check-button.active-check {
  background-color: #28a745; /* Green background for active check */
  color: #fff;
}

.remove-button {
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  background-color: #f8d7da;
  transition: background-color 0.2s;
}

.remove-button:hover {
  background-color: #dc3545; /* Red background on hover */
  color: #fff;
}

.choice-label {
  font-weight: bold;
  width: 30px;
  text-align: right;
}



.choice-input {
  margin-top: 0 !important; /* Override default margin for alignment */
}
</style>